
export default class {
  host: string;

  constructor(host: string) {
    this.host = host;
  }

  accountPath = () => {
    return this.host + "account";
  }

  loginPath = () => {
    return this.host + "perform_login";
  }

  logoutPath = () => {
    return this.host + "perform_logout";
  }

  timelinePath = () => {
    return this.host + "timeline";
  }

  projectListPath = () => {
    return this.host + "timeline/projects";
  }

  popularListPath = () => {
    return this.host + "timeline/popular";
  }

  timelineAll = () => {
    return this.host + "timeline/all"
  }

  timelineUpdated = () => {
    return this.host + "timeline/updated"
  }

  userProfile = (userName: string) => {
    return this.host + "user/" + userName
  }
  userPublicPagePath = (userName: string, publicPageTitle: string) => {
    return this.host + "user/" + userName + "/public-page/" + publicPageTitle;
  }

  publicPageViewing = (publicPageId: number) => {
    return this.host + "public-page/viewing/" + publicPageId;
  }

  followPath = (userName: string) => {
    return this.host + `user/${userName}/follow/`;
  }
  publicBadge = (userName:string) => {
    return this.host + `user/${userName}/badge/`;
  }
  getAllComments = (userName:string) => {
    return this.host + `user/${userName}/comments/`;
  }

  publicPageLiksPath = (userName: string, publicPageTitle: string) => {
    return this.userPublicPagePath(userName, publicPageTitle) + "/like";
  }

  publicPageGoodPath = (userName: string, publicPageTitle: string) => {
    return this.userPublicPagePath(userName, publicPageTitle) + "/good";
  }

  commentsPath = (userName: string, publicPageTitle: string) => {
    return this.userPublicPagePath(userName, publicPageTitle) + "/comments";
  }
  
  commentGetPath = () => {
    return this.host + `public-page/comments/get`;
  }

  commentPostPath = () => {
    return this.host + `public-page/comments/post`;
  }

  commentNicePath = (userName: string, publicPageTitle: string, commentId: string | number) => {
    return this.commentsPath(userName, publicPageTitle) + "/" + commentId + "/nice";
  }


  
  saveUploadSettingPath = () => {
    return this.host + "upload/settings/";
  }
  savePublicPagePath = (projectId?: number) => {
    return this.host + "upload/public-page/" + (projectId === undefined ? "" : projectId);
  }
  deletePublicPagePath = (projectId:number, publicPageId: number) => {
    return this.host + "upload/public-page/" + projectId + "/" + publicPageId;
  }

  getProjectPath = (projectId: string) => {
    return this.host + "upload/project/" + projectId;
  }
  createNewProject = () => {
    return this.host + "upload/create-project";
  }
  
  checkPublicPageTitlePath = (publicPageId: number | null | undefined, title: string) => {
    return this.host + "upload/check-public-page-title?" + ((publicPageId === undefined || publicPageId === null) ? "" : "publicPageId=" + publicPageId + "&") + "title=" + title;
  }

  accountSetting = () => {
    return this.host + "account" + "/email";
  }

  accountSettingPassword = () => {
    return this.host + "account" + "/password";
  }

  accountSettingProfile = () => {
    return this.host + "account" + "/profile";
  }

  accountSettingBadge = () => {
    return this.host + "account" + "/badge";
  }
  accountMyProject = () => {
    return this.host + "account" + "/project";
  }
  

  searchPath = () => {
    return this.host + "search";
  }

  searchPublicPagePath = () => {
    return this.host + "search/public-page";
  }

  searchUserPath = () => {
    return this.host + "search/user";
  }

  postStatistics() {
    return this.host + "public/statistics"
  }

  createSession() {
    return this.host + "account/createCheckoutSession"
  }

  passwordEmailConfirm() {
    return this.host + "forgot/password/email-confirm"
  }
  passwordTokenConfirm() {
    return this.host + "forgot/password/token-confirm"
  }
  passwordSave() {
    return this.host + "forgot/password/save"
  }

  contactToConsult() {
    return this.host + "contact/consultation"
  }
  
  contactToEntryProgramming() {
    return this.host + "contact/programming-course"
  }
  
  signupEmail() {
    return this.host + "signup"
  }
  signupTokenConfirm() {
    return this.host + "signup/confirm-token"
  }
  activate() {
    return this.host + "signup/activate"
  }
}
